import {localCommand} from "../utils/api";

export const ADD_SKILL_OPTION = 'ADD_SKILL_OPTION';
export const ADD_SKILL_OPTION_SUCCESS = 'ADD_SKILL_OPTION_SUCCESS';
export const ADD_SKILL_OPTION_FAILED = 'ADD_SKILL_OPTION_FAILED';
export const addSkillOption = localCommand('v1/skillOption/AddSkillOption', ADD_SKILL_OPTION, ADD_SKILL_OPTION_SUCCESS,
  ADD_SKILL_OPTION_FAILED);